var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChippingArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5134_361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7118 2.0375C11.721 1.046 10.4025 0.5 9 0.5C7.5975 0.5 6.27975 1.046 5.2875 2.0375C3.24075 4.08425 3.24075 7.415 5.2935 9.46775L9 13.0925L12.7118 9.46175C13.7032 8.47025 14.25 7.15175 14.25 5.74925C14.25 4.34675 13.7032 3.02975 12.7118 2.0375ZM9 7.9925C7.75725 7.9925 6.75 6.98525 6.75 5.7425C6.75 4.49975 7.75725 3.4925 9 3.4925C10.2428 3.4925 11.25 4.49975 11.25 5.7425C11.25 6.98525 10.2428 7.9925 9 7.9925ZM0.57525 14.0007L5.3385 14.0082L4.77525 18.5H0L0.01125 17.2467L0.57525 14.0007ZM5.60625 11.8722L5.52675 12.5082L0.83625 12.5007L1.61925 7.99925H2.63625C2.9685 8.942 3.51225 9.8075 4.245 10.5402L5.60625 11.8722ZM18 17.3743V18.4993H13.2247L12.663 14.0195L17.4217 14.027L18 17.3743ZM11.151 14.0173L11.7135 18.4993H6.28725L6.8505 14.0105L7.79475 14.012L9.00075 15.191L10.2022 14.0157L11.1518 14.0173H11.151ZM17.163 12.527L12.4747 12.5195L12.3937 11.8715L13.773 10.5223C14.4975 9.79775 15.0367 8.9375 15.3675 7.99925H16.3807L17.163 12.527Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5134_361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChippingArea);
export default __webpack_public_path__ + "static/media/ChippingArea.36e010e36d8825754c61dfee4985958f.svg";
export { ForwardRef as ReactComponent };